(() => {
  const bar = document.getElementById('vcSticky');
  if (bar) {
    const sync = () => {
      const busy = document.querySelector('cart-drawer.active, #cart-notification.active, .header__search details[open], #menu-drawer-container[open], product-modal[open]');
      bar.classList.toggle('vc-sticky-atc--covered', Boolean(busy));
    };
    const observer = new MutationObserver(sync);
    document.querySelectorAll('cart-drawer, #cart-notification, .header__search details, #menu-drawer-container, product-modal').forEach(node => observer.observe(node, {attributes:true,attributeFilter:['class','open']}));
    sync();
  }
  const part = new URLSearchParams(location.search).get('part');
  if (part && location.pathname === '/pages/contact-us') {
    const field = document.querySelector('#warranty_form_en input[name="contact[product_reference]"]');
    if (field && !field.value) field.value = part.slice(0,120);
  }
})();

(() => {
  document.querySelectorAll('.vc-fitment-enquiry').forEach(panel => {
    const form = panel.querySelector('form');
    form.addEventListener('submit', event => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      const data = new FormData(form), vehicle = ['year','make','model','engine','oe'].map(key => String(data.get(key) || '').trim()).filter(Boolean).join(' / ');
      const result = panel.querySelector('.vc-vehicle-result');
      result.querySelector('p').textContent = panel.dataset.result;
      const link = new URL(panel.dataset.contact, location.origin);
      link.searchParams.set('part',panel.dataset.part || '');
      link.searchParams.set('vehicle',vehicle);
      result.querySelector('a').href = link.pathname + link.search;
      result.hidden = false;
    });
  });
  document.querySelectorAll('.vc-part-links a, a[href="#vc-part-specifications"], a[href="#vc-full-details"]').forEach(link => link.addEventListener('click', () => {
    const target = document.getElementById(link.hash.slice(1));
    if (target) { let parent = target.parentElement; while (parent) { if (parent.tagName === 'DETAILS') parent.open = true; parent = parent.parentElement; } }
  }));
  if (location.pathname === '/pages/contact-us') {
    const vehicle = new URLSearchParams(location.search).get('vehicle');
    const message = document.querySelector('textarea[name="contact[body]"]');
    if (vehicle && message && !message.value) message.value = 'Please help check fitment for: ' + vehicle.slice(0,350);
  }
})();
